import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/smartphone-charging.vue
var o = {
	name: "DtIconSmartphoneCharging",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--smartphone-charging"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Smartphone Charging",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M3.5 1.5A.5.5 0 0 0 3 2v8a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 9 10V2a.5.5 0 0 0-.5-.5h-5ZM2 2A1.5 1.5 0 0 1 3.5.5h5A1.5 1.5 0 0 1 10 2v8a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 2 10V2Z",
		"clip-rule": "evenodd"
	}, null, -1), r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6.61 3.584a.5.5 0 0 1 .14.693L5.934 5.5H7a.5.5 0 0 1 .416.777l-1.333 2a.5.5 0 0 1-.833-.554L6.066 6.5H5a.5.5 0 0 1-.416-.777l1.333-2a.5.5 0 0 1 .694-.139Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=smartphone-charging.js.map